import { ICustomerInvoiceModel } from "../entities-generated/models/project/customer-invoice-model";
import { AuthApiClient } from "./auth-api-client";

class InvoiceApiClientClass {
  public getCustomerInvoice(invoiceId: string) {
    return AuthApiClient.get<ICustomerInvoiceModel>(`invoices/${invoiceId}`);
  }

  public downloadTransactionDocument(receiptId: string) {
    return AuthApiClient.download(`invoices/download/${receiptId}`);
  }
}

export const InvoiceApiClient = new InvoiceApiClientClass();